import { useForethoughtContext } from '@modules/support/forethought';
import { handoffState } from '@modules/support/utils/handoffState';
import { useZendeskContext } from '@modules/support/zendesk';

export const useChatContext = () => {
  const {
    open: openZendesk,
    close: closeZendesk,
    isLoaded: isLoadingZendesk,
    isOpen: isZendeskOpen,
  } = useZendeskContext();

  const {
    open: openForethought,
    close: closeForethought,
    isLoading: isLoadingForethought,
    isOpen: isForethoughtOpen,
    isError,
  } = useForethoughtContext();

  // Determines which widget to open at execution time based on handoff expiration time.
  const open = () =>
    isError || handoffState.getHandoffState() ? openZendesk() : openForethought();
  // Pre-selects the appropriate close function to ensure the current widget gets closed first,
  // then the variable can be reassigned if handoff state changes
  const close = isError || handoffState.getHandoffState() ? closeZendesk : closeForethought;
  const isLoading = !isLoadingZendesk || isLoadingForethought;
  const isOpen = isZendeskOpen || isForethoughtOpen;

  return {
    isOpen,
    open,
    close,
    isLoading,
    isError,
  };
};

export default useChatContext;
